let currentToken;

export default (store) => () => {
  let previousToken = currentToken;
  currentToken = store.getState().auth.authToken;
  if (previousToken !== currentToken) {
    if (currentToken) {
      localStorage.setItem('portalAdminAuthToken', currentToken);
    } else {
      localStorage.removeItem('portalAdminAuthToken');
    }
  }
}
